import vosClient, { IVosResponse } from "../../vosClient";

export interface IGetEmployeeListParams {
  keySearch?: string;
  depID?: any;
  module: string;
}

export interface IGetEmployee {
  UserID: string;
  UserCode: string;
  UserName: string;
  UserType: string;
  Level_1_Code: string;
  Level_2_Code: string;
  Level_3_Code: string;
  Level_1_Name: string;
  Level_2_Name: string;
  Level_3_Name: string;
  Code_Job_Title: string;
  Name_Job_Title: string;
  Dep_Code: string;
  Dep_Name: string;
  HR_ID: number;
  Email: string;
}

export interface DepartmentItem {
  Code: string;
  Name_VN: string;
  ParentID: number;
}

export interface EmployeeInfo {
  HR_ID: number;
  HR_No: string;
  Dep_ID: number;
  FullName: string;
  BirthDay: string; // hoặc Date nếu bạn muốn parse
  Email: string;
  DepList: DepartmentItem[];
  Dep_Code: string;
  Dep_Name_VN: string;
  Code_Job_Title: string;
  JobTitle_NameVN: string;
}

export interface IGetHRProfileParams {
  email: string;
}

export interface OrgLevelsItem {
  Code: string;
  Name_VN: string;
  ParentID: number;
}

export interface IHRProfile {
  UserID: string;
  UserCode: string;
  UserName: string;
  UserType: string;
  Phone: string;
  Email: string;
  Gmail: string;
  Code_Job_Title: string;
  JobTitle_NameVN: string;
  Parent_Data: string;
  OrgLevels: OrgLevelsItem[];
  HR_ID: number;
  Dep_ID: number;
  DepName_VN: string;
}

export class EmployeeService {
  static async getEmployeeList(params?: IGetEmployeeListParams) {
    const response = await vosClient.get<IVosResponse<IGetEmployee[]>>("/api/department/hr-data-search", {
      params,
    });

    return response.data;
  }

  static async getHRProfile(params?: IGetHRProfileParams) {
    const response = await vosClient.get<IVosResponse<IHRProfile[]>>("/api/department/hr-profile-get-email", {
      params,
    });

    return response.data.Data.at(0);
  }
}
